import { api } from "@/redux/api";

import {
	FrameworkEffectivenessQueryParams,
	FrameworkEffectivenessSummary,
	FrameworkEffectivenessSummarySchema,
} from "./frameworkEffectiveness.schema";

export const frameworkEffectivenessApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getFrameworkEffectivenessSummary: builder.query<
			FrameworkEffectivenessSummary,
			FrameworkEffectivenessQueryParams | void
		>({
			query: (params) => ({
				url: "framework-effectiveness/summary",
				params: params || undefined,
				responseSchema: FrameworkEffectivenessSummarySchema,
			}),
			providesTags: ["FrameworkEffectiveness"],
		}),
	}),
});

export const { useGetFrameworkEffectivenessSummaryQuery } = frameworkEffectivenessApi;
